module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/cenicilla_pepino/preventiva/vacciplant.png
// module id = 2104
// module chunks = 3